import type { GetMetadata } from './types'

export const getMetadata = ({ content, language }: GetMetadata) => {
  const contentMetadata = content?.metadatas?.find((metadata) => metadata.language === language)

  return contentMetadata ?? content?.metadatas?.[0] ?? undefined
}
